import Vue from 'vue'
import Vuex from 'vuex'
import { UserModuleStore } from '@dracul/user-frontend'
import { CustomizationStore } from '@dracul/customize-frontend'
import BaseModuleStore from '../modules/base/storage/BaseModuleStore'
import companyBrandingStore from '../modules/user-configuration/storage/companyBrandingStore'

Vue.use(Vuex)

import createPersistedState from "vuex-persistedstate";

export default new Vuex.Store({
    modules: {
        user: UserModuleStore,
        base: BaseModuleStore,
        customization: CustomizationStore,
        companyBranding: companyBrandingStore,
    },
    plugins: [
        createPersistedState({
            key: process.env.VUE_APP_KEY,
            paths: ['user'],
            reducer: state => (
                {
                    user: {
                        access_token: state.user.access_token,
                        refresh_token: state.user.refresh_token,
                        me: state.user.me,
                        avatarurl: state.user.avatarurl,
                        companyId: state.user.companyId
                    },
                    customization: {
                        colors: state.customization.colors,
                        logo: state.customization.logo,
                        language: state.customization.language
                    },
                })
        })
    ]
})
